import { getSdk } from "./sdkService";
import { generateRandomNumber } from "../utils/commonUtils";

/**
 * Uses the SDK to perform a login and in case of being successful, the app store is notified that the user is logged in
 * so that the app UI is updated accordingly.
 * @param {string} username The user name of the account found in local storage
 * @param {string} password The password of the account found in local storage
 * @returns {Promise}
 */
export async function generatePin() {
  try {
    const sdk = await getSdk();
    const pinResponse = await sdk.userManager.generatePin();
    return pinResponse;
  } catch (error) {
    throw error;
  }
}

/**
 * Uses the SDK to perform a login and in case of being successful, the app store is notified that the user is logged in
 * so that the app UI is updated accordingly.
 * @param {string} username The user name of the account found in local storage
 * @param {string} password The password of the account found in local storage
 * @returns {Promise}
 */
export async function loginPin(data) {
  try {
    const sdk = await getSdk();
    const pinResponse = await sdk.userManager.loginPin(data);
    return pinResponse;
  } catch (error) {
    throw error;
  }
}

/**
 * Uses the SDK to perform a guest sigup on every app launch
 * so that the app UI is updated accordingly.
 * @param {string} language The user name of the account found in local storage
 * @param {string} country The password of the account found in local storage
 * @returns {Promise}
 */
export async function guestSignup(
  language,
  country,
  profileType = "EV",
  autologin = true,
  cookie = true,
  service = "guestSignup"
) {
  try {
    const sdk = await getSdk();
    const getTVRealModel = await sdk.systemManager.device.getRealModel();
    const uniqueReference = getTVRealModel
      ? getTVRealModel + new Date().getTime()
      : generateRandomNumber() + new Date().getTime();
    const data = {
      service: service,
      language: language,
      uniqueReference: uniqueReference,
      profileType: profileType,
      autologin: autologin,
      country: country,
      cookie: cookie
    };

    const guestSignupResponse = await sdk.userManager.signup(data);
    localStorage.setItem("state", "LoggedOut"); // setting LoggedOut state for guest user
    return guestSignupResponse;
  } catch (error) {
    throw error;
  }
}
